export const ACCESS_TOKEN_KEY = "ACCESS_TOKEN";
export const IS_TRUSTED_DEVICE = "IS_TRUSTED_DEVICE";
